import { useState, useEffect } from "react";
import KadanaCopilot from "@/components/KadanaCopilot";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, X } from "lucide-react";

// Floating right-side Copilot dock, mounted globally so it appears on public and authenticated pages.
export default function CopilotDock() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const endpoint = user ? "/copilot" : "/public/copilot";

  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener("open-copilot", onOpen);
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => { window.removeEventListener("open-copilot", onOpen); window.removeEventListener("keydown", onKey); };
  }, []);

  return (
    <>
      {/* Launcher */}
      {!open && (
        <button data-testid="copilot-launcher" onClick={() => setOpen(true)}
          style={{ position: "fixed", right: 22, bottom: 22, zIndex: 1400, display: "flex", alignItems: "center",
            gap: 8, padding: "12px 18px", borderRadius: 999, border: "1px solid var(--accent-primary)",
            background: "var(--accent-primary)", color: "#111113", fontWeight: 700, cursor: "pointer",
            boxShadow: "0 6px 20px rgba(17,17,19,.35)" }}>
          <Sparkles size={16} /> Ask Copilot
        </button>
      )}

      {/* Right-side dock panel */}
      {open && (
        <div data-testid="copilot-dock" style={{ position: "fixed", top: 0, right: 0, bottom: 0, zIndex: 1401,
          width: "min(440px, 100vw)", background: "var(--canvas)", borderLeft: "1px solid var(--border-strong)",
          boxShadow: "-8px 0 30px rgba(17,17,19,.4)", display: "flex", flexDirection: "column",
          padding: 14, gap: 10 }} className="k-fadein">
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button className="k-btn k-btn-ghost" data-testid="copilot-dock-close" onClick={() => setOpen(false)}
              style={{ padding: "6px 10px" }}><X size={16} /> Close</button>
          </div>
          <div style={{ flex: 1, minHeight: 0 }}>
            <KadanaCopilot height="100%" endpoint={endpoint} />
          </div>
        </div>
      )}
    </>
  );
}
